<template>
    <div style="position: relative;">
        <img style="position: relative; top: 0;" :class="this.class" :src="'/img/logo_v2'+($page.props.env !== undefined ? ('_'+$page.props.env) : '')+(this.full!==undefined ? '_full' : '')+'.png'" alt="DSchránka">
    </div>
</template>

<script>

export default {
    props: ['class', 'full'],
}
</script>

<style scoped>
</style>
